(ns shared.core.debug.datafrisk.views
  (:require [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]))

;; Modified Form Of
;; https://github.com/Odinodin/data-frisk-reagent/blob/1aea18c26a819ef2f97f64184be74373da3722eb/src/datafrisk/view.cljs

(declare data-frisk)

(defn expand-button [{:keys [expanded? path emit-fn]}]
  [:button {:style {:border 0
                    :background-color :transparent
                    :width 10
                    :height 10
                    :padding "0 3px 0 0"
                    :outline :none}
            :on-click #(emit-fn (if expanded? :contract :expand) path)}
   [:svg {:view-box "0 0 100 100"
          :width "100%"
          :height "100%"
          :style {:transition "all 0.2s ease"
                  :transform (when expanded? "rotate(90deg)")
                  :fill "#fff"}}
    [:polygon {:points "0,0 0,100 100,50"
               :stroke "white"}]]])

(def styles
  {:shell {:background-color "#1b1b1b"
           :font-family "Consolas,Monaco,Courier New,monospace"
           :font-size 12
           :z-index (style/z :low)}
   :strings {:color "#A5C25C"}
   :keywords {:color "#9876AA"}
   :numbers {:color "#6897BB"}
   :nil {:color "#D25252"}
   :shell-visible-button {:backgroundColor "#4EE24E"}})

(def paren-styles {:color "#fff"})

(defn nil-text []
  [:span {:style (:nil styles)} (pr-str nil)])

(defn string-text [data]
  [:span {:style (:strings styles)} (pr-str data)])

(defn keyword-text [data]
  [:span {:style (:keywords styles)} (str data)])

(defn number-text [data]
  [:span {:style (:numbers styles)} data])

(defn node [{:keys [data path emit-fn swappable]}]
  [:div (cond
          (nil? data)
          [nil-text]

          (string? data)
          (if swappable
            [:input {:type "text"
                     :default-value (str data)
                     :on-change (fn string-changed [e]
                                  (emit-fn :changed path (.. e -target -value)))}]
            [string-text data])

          (keyword? data)
          (if swappable
            [:input {:type "text"
                     :default-value (name data)
                     :on-change (fn keyword-changed [e]
                                  (emit-fn :changed path (keyword (.. e -target -value))))}]
            [keyword-text data])

          (object? data)
          (str data " " (.stringify js/JSON data))

          (number? data)
          (if swappable
            [:input {:type "number"
                     :default-value data
                     :on-change (fn number-changed [e]
                                  (emit-fn :changed path (js/Number (.. e -target -value))))}]
            [number-text data])
          :else
          [:span {:style {:color "#CC7832"}}
           (str data)])])

(defn key-val-node [{[k v] :data :keys [path expanded-paths emit-fn swappable]}]
  [:div {:style {:display :flex}}
   [:div {:style {:flex "0 0 auto"
                  :padding 2}}
    [node {:data k}]]
   [:div {:style {:flex 1
                  :padding 2}}
    [data-frisk {:data v
                 :swappable swappable
                 :path (conj path k)
                 :expanded-paths expanded-paths
                 :emit-fn emit-fn}]]])

(defn list-vec-node [{:keys [data path expanded-paths emit-fn swappable]}]
  (let [expanded? (get expanded-paths path)]
    [:div {:style {:display "flex"}}
     (when-not (empty? data)
       [:div {:style {:flex "0 1 auto"}}
        [expand-button {:expanded? expanded?
                        :path path
                        :emit-fn emit-fn}]])
     [:div {:style {:color (-> styles :numbers :color)
                    :flex 1}}
      [:span {:style paren-styles}
       (if (vector? data) "[" "(")]
      (if expanded?
        (map-indexed (fn [i x] ^{:key i} [data-frisk {:data x
                                                      :swappable swappable
                                                      :path (conj path i)
                                                      :expanded-paths expanded-paths
                                                      :emit-fn emit-fn}]) data)
        (str (count data) " items"))
      [:span {:style paren-styles}
       (if (vector? data) "]" ")")]]]))

(defn set-node [{:keys [data path expanded-paths emit-fn swappable]}]
  (let [expanded? (get expanded-paths path)]
    [:div {:style {:display "flex"}}
     (when-not (empty? data)
       [:div {:style {:flex "0 1 auto"}}
        [expand-button {:expanded? expanded?
                        :path path
                        :emit-fn emit-fn}]])
     [:div {:style {:color (-> styles :numbers :color)
                    :flex 1}} [:span {:style paren-styles} "#{"]
      (if expanded?
        (map-indexed (fn [i x]
                       ^{:key i}
                       [data-frisk {:data x
                                    :swappable swappable
                                    :path (conj path x)
                                    :expanded-paths expanded-paths
                                    :emit-fn emit-fn}]) data)
        (str (count data) " items"))
      [:span {:style paren-styles}
       "}"]]]))

(defn key-set [ks]
  [:span
   (->> (map-indexed
          (fn [i data]
            ^{:key i}
            [:span
             (cond (nil? data) [nil-text]
                   (string? data) [string-text data]
                   (keyword? data) [keyword-text data]
                   (number? data) [number-text data]
                   :else (str data))]) ks)
        (interpose " "))])

(defn map-node [{:keys [data path expanded-paths emit-fn] :as all}]
  (let [expanded? (get expanded-paths path)]
    [:div {:style {:display :flex}}
     [:div {:style {:flex "0 1 auto"}}
      [expand-button {:expanded? expanded?
                      :path path
                      :emit-fn emit-fn}]]
     [:div {:style {:flex 1}}
      [:span {:style paren-styles} "{"]
      (if expanded?
        (map-indexed (fn [i x] ^{:key i} [key-val-node (assoc all :data x)]) data)
        [key-set (keys data)])
      [:span {:style paren-styles} "}"]]]))

(defn data-frisk [{:keys [data] :as all}]
  (cond (map? data) [map-node all]
        (set? data) [set-node all]
        (or (seq? data) (vector? data)) [list-vec-node all]
        (satisfies? IDeref data) [data-frisk (assoc all :data @data)]
        :else [node all]))

(defn conj-to-set [coll x]
  (conj (or coll #{}) x))

(defn expand-all-paths [root-value]
  (loop [remaining [{:path [] :node root-value}]
         expanded-paths #{}]
    (if (seq remaining)
      (let [[current & rest] remaining
            current-node (if (satisfies? IDeref (:node current)) @(:node current) (:node current))]
        (cond (map? current-node)
              (recur
                (concat rest (map (fn [[k v]] {:path (conj (:path current) k)
                                               :node v})
                                  current-node))
                (conj expanded-paths (:path current)))
              (or (seq? current-node) (vector? current-node))
              (recur
                (concat rest (map-indexed (fn [i node] {:path (conj (:path current) i)
                                                        :node node})
                                          current-node))
                (conj expanded-paths (:path current)))
              :else
              (recur
                rest
                (if (coll? current-node)
                  (conj expanded-paths (:path current))
                  expanded-paths))))
      expanded-paths)))

(defn emit-fn-factory [state-atom* id swappable]
  (fn [event & args]
    (case event
      :expand (swap! state-atom* update-in [:frisk id :expanded-paths] conj-to-set (first args))
      :expand-all (swap! state-atom* assoc-in [:frisk id :expanded-paths] (expand-all-paths (first args)))
      :contract (swap! state-atom* update-in [:frisk id :expanded-paths] disj (first args))
      :collapse-all (swap! state-atom* assoc-in [:frisk id :expanded-paths] #{})
      :changed (let [[path value] args]
                 (if (seq path)
                   (swap! swappable assoc-in path value)
                   (reset! swappable value))))))

(defn data-frisk-shell [{:keys [style]} & data]
  (let [expand-by-default (reduce #(assoc-in %1 [:frisk %2 :expanded-paths] #{[]})
                                  {}
                                  (range (count data)))
        state-atom* (re/ratom expand-by-default)]
    (fn [& data]
      (into [:div {:style (merge {:flex 1
                                  :padding 10
                                  :overflow :auto}
                                 (:shell styles))}]
            (map-indexed (fn [id x]
                           (let [frisk (:frisk @state-atom*)
                                 swappable (when (satisfies? IAtom x)
                                             x)
                                 emit-fn (emit-fn-factory state-atom* id swappable)]
                             [:div {:style {:max-height "100%"}}
                              [:div {:style {:display :flex
                                             :padding "0 0 15px"}}
                               [c/white-button {:on-click #(emit-fn :expand-all x)
                                                :style {:margin-right 8}
                                                :size :small}
                                "Expand All"]
                               [c/white-button {:on-click #(emit-fn :collapse-all)
                                                :size :small}
                                "Collapse All"]]
                              [data-frisk {:data x
                                           :swappable swappable
                                           :path []
                                           :expanded-paths (get-in frisk [id :expanded-paths])
                                           :emit-fn emit-fn}]]))
                         data)))))
